/* Mizori — mobiel menu accordion (drawer-open/close via window.mzSide uit cart.js) */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.mz-mnav__toggle');
    if (!toggle) return;
    e.preventDefault();
    var li = toggle.closest('.mz-mnav__item');
    var open = li.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();
